import { render, staticRenderFns } from "./noticeCenter.vue?vue&type=template&id=071e2f97&scoped=true"
import script from "./noticeCenter.vue?vue&type=script&lang=js"
export * from "./noticeCenter.vue?vue&type=script&lang=js"
import style0 from "./noticeCenter.vue?vue&type=style&index=0&id=071e2f97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071e2f97",
  null
  
)

export default component.exports